<template>
  <div class="activity-list">
    <swiper
      ref="mySwiper"
      :options="swiperOption"
      v-if="activityList && activityList.length"
    >
      <swiper-slide>
        <img class="activity-icon" src="../images/hitbox-icon-box.jpg" alt="" />
      </swiper-slide>
      <template>
        <swiper-slide v-for="(item, index) of activityList" :key="index">
          <img class="activity-icon" :src="item.imgUrl" alt="" />
        </swiper-slide>
      </template>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
    <div class="activity-hitbox" @click="openHitBoxDialog()" v-else>
      <img class="activity-icon" src="../images/hitbox-icon-box.jpg" alt="" />
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';
export default {
  name: 'ActivityList',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {},
  data() {
    return {
      activityList: []
    };
  },
  watch: {},
  computed: {
    swiperOption() {
      const self = this;
      return {
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        slidesPerView: 1, // 同时显示的Slide数量
        // centeredSlides: true, // 中间的Slide是否对齐容器中心
        // spaceBetween: 30, // Slide之间的间隔
        slideClass: 'custom-slide-class',
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'custom' // 自定义指示器
        // },
        on: {
          click: function(el) {
            console.log(el, this, this.realIndex, this.realIndex === 0);
            if (el.target.className === 'activity-icon') {
              if (this.realIndex === 0) {
                self.openHitBoxDialog();
              } else {
                self.openActivity(self.activityList[this.realIndex - 1].h5Url);
              }
            }
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      };
    }
  },
  methods: {
    async getActivityList() {
      const { data } = await this.$http.get('/activity/infoList');
      this.activityList = data;
    },
    openActivity(url) {
      window.open(url, '_blank');
    },
    openHitBoxDialog() {
      this.$emit('open-hitbox-dialog');
    }
  },
  created() {
    this.getActivityList();
  }
};
</script>
<style lang="scss" scoped>
.activity-list {
  position: absolute;
  bottom: 118px;
  width: 80px;
  height: 100px;
  right: 10px;
}

.activity-icon {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50%;
  cursor: pointer;
}
.activity-hitbox {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
<style lang="scss">
.activity-list {
  --swiper-navigation-size: 14px;
  --swiper-theme-color: #baa5b9;
  background: rgba(225, 225, 225, 0.1);
  .swiper-container {
    height: 100%;
  }
  .swiper-container,
  .swiper-wrapper {
    width: 100% !important;
  }
  .swiper-wrapper {
    height: 80px;
  }
  .custom-slide-class {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
  }
  .swiper-container-horizontal > .swiper-pagination-bullets,
  .swiper-pagination-custom,
  .swiper-pagination-fraction {
    bottom: 9px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    top: 84%;
  }
}
</style>
